import { MenuProps } from "antd";
import classNames from "classnames";
import React from "react";

import {
    NavBarAnchorType,
    NavBarDropdownItem,
    NavBarDropdownItemGroup,
} from "../../component-queries/types";
import PdfAnchor from "../PdfAnchor";
import LinkOut from "./LinkOut";
import { COLLECTION_COMPONENTS_MAP } from "./constants";

const {
    groupTitle,
    hasBottomBorder,
} = require("../../style/navbarDropdown.module.css");

const isGroupedItems = (
    items: NavBarDropdownItem[] | NavBarDropdownItemGroup[],
): items is NavBarDropdownItemGroup[] => {
    return items.length > 0 && "options" in items[0];
};

const getItemComponent = (item: NavBarDropdownItem) => {
    if (item.anchorType === NavBarAnchorType.Download) {
        return <PdfAnchor label={item.label} href={item.href} />;
    }

    if (item.anchorType === NavBarAnchorType.Internal) {
        return <LinkOut label={item.label} href={item.href} samePage={true} />;
    }

    if (COLLECTION_COMPONENTS_MAP[item.label]) {
        return (
            <LinkOut
                label={COLLECTION_COMPONENTS_MAP[item.label]}
                href={item.href}
            />
        );
    }

    return <LinkOut label={item.label} href={item.href} />;
};

const getFlatItems = (items: NavBarDropdownItem[]): MenuProps["items"] => {
    return items.map((item, idx) => {
        return {
            key: item.label,
            className: idx < items.length - 1 ? hasBottomBorder : undefined,
            label: getItemComponent(item),
        };
    });
};

const getGroupedMenuItems = (
    groups: NavBarDropdownItemGroup[],
): MenuProps["items"] => {
    return groups.map((group, groupIndex) => ({
        type: "group" as const,
        label: (
            <div className={classNames(hasBottomBorder, groupTitle)}>
                {group.label}
            </div>
        ),
        key: `group-${groupIndex}`,
        children: group.options.map((item) => {
            return {
                key: item.label,
                label: getItemComponent(item),
            };
        }),
    }));
};

export const formatDropdownMenuItems = (
    items: NavBarDropdownItem[] | NavBarDropdownItemGroup[],
): MenuProps["items"] => {
    if (isGroupedItems(items)) {
        return getGroupedMenuItems(items);
    }
    return getFlatItems(items);
};
